export const APP_ROUTE_PARAM_PATTERN = "/:applyId/:step?/:card?";

export default {
  APP_ROUTE_PARAM_PATTERN
};
